(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_708c94f"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dgr-ingredients')){customElements.define('dgr-ingredients',class extends HTMLElement{
connectedCallback(){this.abort=new AbortController();const options={signal:this.abort.signal};this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('.dgr-ingredients-link');this.trigger.addEventListener('click',()=>this.dialog.showModal(),options);this.querySelector('.dgr-dialog-close').addEventListener('click',()=>this.dialog.close(),options);this.dialog.addEventListener('click',event=>{const r=this.dialog.getBoundingClientRect();if(event.target===this.dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))this.dialog.close()},options);this.dialog.addEventListener('close',()=>this.trigger.focus(),options)}
disconnectedCallback(){this.abort?.abort();if(this.dialog?.open)this.dialog.close()}
})}
  } catch(e) { console.error(e); }
})();

})();
